import React from "react";
import "primeflex/primeflex.css";
import { Outlet } from "react-router-dom";
import SideNav from "./SideNav";
import styles from "./Page.css"

export default function Page({ toggleFlag }) {
  return (
    <div className="grid flex">
      <div
        className={`side-nav transition border-right-1 border-300 ${toggleFlag ? "col-1 p-0 md:inline drawer-hidden sidenav-width" : "col-2 p-0"}`}
      >
        <SideNav isMinimized={toggleFlag} />
      </div>
      <div className={`transition ${toggleFlag ? "col-11 p-2 bg-container" : "col-10 p-2 bg-container"}`}>
        <Outlet/>
      </div>
    </div>
  );
}
